import React from "react";
import { Subscription } from "react-apollo";
import { httpClient } from "settings/apolloClient";
import {
  AUTHORIZED_OPERATOR_QUERY,
  SUBSCRIBE_TO_OPERATOR_CHANGE,
} from "contexts/AuthorizedOperatorContext";

// Keeps the "operator in command" live for the whole session by writing each
// change into the httpClient cache that AuthorizedOperatorContext reads. A
// single backend poller (AutomationOperatorPoller) publishes on change, so a
// take/release of command from any client, the API or the controller reflects
// on every open screen without per-client polling.
//
// Mounted in the Admin layout (not a page) for the same reason as
// AutomationStatusSubscriber: navigation must not tear the notifier down and
// re-trigger the @absinthe/socket resubscribe race.
const OperatorSubscriber = () => (
  <Subscription
    subscription={SUBSCRIBE_TO_OPERATOR_CHANGE}
    fetchPolicy="no-cache"
    onSubscriptionData={({ subscriptionData }) => {
      const data = subscriptionData && subscriptionData.data;

      if (!data) return;

      httpClient.writeQuery({
        query: AUTHORIZED_OPERATOR_QUERY,
        data: { getCurrentAutomationOperator: data.subscribeToOperatorChange || null },
      });
    }}
  >
    {() => null}
  </Subscription>
);

export default OperatorSubscriber;
